import FirebaseAuthProvider from "./firebase-auth-provider";

export default class EmailAuthProvider extends FirebaseAuthProvider {
  constructor(firebaseConfig, returnUrl) {
    super('email', firebaseConfig);
    this.returnUrl = returnUrl;
  }

  authorize(authData) {
    let actionCodeSettings = {
      url: this.returnUrl,
      handleCodeInApp: true
    };

    firebase
      .auth()
      .sendSignInLinkToEmail(authData.email, actionCodeSettings)
      .then(() => {
        this._saveUserData({ email: authData.email });
        this.trigger({
          type: 'providerInstructionsSent',
          data: {
            provider: this.name
          }
        });
      })
      .catch((error) => {
        var errorMessage;
        switch (error.code) {
          case "auth/invalid-recipient-email":
            errorMessage = 'Указан некорректный адрес электронной почты. Воспользуйтесь другим';
            break;
          default:
            errorMessage = 'При отправке инструкций возникли ошибки. Попробуйте позже'
            break;
        }
        this.trigger({
          type: 'providerError',
          data: {
            provider: this.name,
            error: {
              message: errorMessage
            }
          }
        });
      });
  }

  isUserAuthorized() {
    return firebase.auth().isSignInWithEmailLink(this.returnUrl);    
  }

  /**
   * Авторизация пользователя после прохождения процедуры подтверждения адреса электронной почты
   */
  restoreUserAuth() {
    let userData = this._getUserData();
    if (!userData) {
      return;
    }

    this.trigger({
      type: 'providerAuthorized',
      data: {
        provider: this.name,
        userData: userData
      }
    });
  }

  _saveUserData(userData) {
    const encodedUserData = btoa(JSON.stringify(userData));
    document.cookie = `chat_email_user=${encodedUserData};path=/`;
  }

  _getUserData() {
    let matches = document.cookie.match(new RegExp('(?:^|; )' + 'chat_email_user=([^;]*)'));
    return matches ? JSON.parse(atob(matches[1])) : undefined;
  }
}
